/* eslint-disable @typescript-eslint/no-explicit-any */
import { PetResponse } from 'components/MyPet/MyPet';
import { REQUEST_METHOD } from 'src/helpers/MyPetsHelper';
import { apiRequest } from 'src/utils/apiWrapper';
import { groomingApi } from 'src/utils/nextApiConfig';

/**
 * Helper function to create or update a pet's information in the grooming system
 * @param petItem Pet data to be created or updated
 * @param userDetails User information
 * @param storeInfo Store information containing company ID
 * @param birthDate Optional birth date to override petItem birth date
 * @param saveToProfile Whether to save pet to user profile
 * @param setMyTimeChildId Callback function to set MyTime Child ID
 * @param petBreed Optional breed information to override petItem breed
 * @returns The API response
 */
export const createUpdatePet = async (
  petItem: PetResponse,
  userDetails: any,
  storeInfo: {
    companyId: string | number;
  },
  birthDate: string | number | null | undefined,
  saveToProfile: boolean,
  petBreed?: string,
  phoneNumber?: string,
  setMyTimeChildId?: (myTimeChildID: { myTimeChildId: number }) => void
): Promise<any> => {
  const createUpdatePetData = {
    userPetId: '',
    PetName: petItem?.Petname || petItem?.Name,
    petdateofbirth:
      petItem?.BirthdateString ||
      birthDate ||
      (petItem?.Birthdate
        ? new Date(petItem.Birthdate).toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
          })
        : ''),
    BreedName: petItem?.BreedName || petBreed,
    PreviousPetName: '',
    firstName: userDetails?.FirstName,
    lastName: userDetails?.LastName,
    email: userDetails?.Email,
    phone: phoneNumber || userDetails?.Phone.trim() || userDetails?.xp?.HomePhone.trim(),
    SaveToProfile: saveToProfile,
    GroomingCompanyId: Number(storeInfo.companyId),
  };

  try {
    const options = {
      method: REQUEST_METHOD?.post,
      data: createUpdatePetData,
    };
    const res: PetResponse[] = await apiRequest(groomingApi.createUpdatePet, options);

    // Pass response to callback if provided
    if (setMyTimeChildId) {
      setMyTimeChildId(res as any);
    }

    return res;
  } catch (err) {
    if (setMyTimeChildId) {
      setMyTimeChildId({ myTimeChildId: 0 });
    }
    console.error('@@Error', err);
    // throw err;
  }
};
